import React from 'react';
import { Route, Routes, Navigate } from 'react-router-dom';
import { DashBoard } from '../../pages/DashBoard/DashBoard';
import { KeyWordVer1 } from '../../pages/KeyWordVer1/KeyWordVer1';
import { KeyWordVer2 } from '../../pages/KeyWordVer2/KeyWordVer2';
import { FindMid } from '../../pages/FindMid/FindMid';
import { FindNaverRank } from '../../pages/FindNaverRank/FindNaverRank';
import { FindNaverRankTracking } from '../../pages/FindNaverRankTracking/FindNaverRankTracking';
import { Login } from '../../pages/Login/Login';
import ProtectedRoute from '../ProtectedRoute';

const Layout = () => {
    return (
        <Routes>
            <Route path="/login" element={<Login />} />
            <Route
                path="/"
                element={
                    <ProtectedRoute>
                        <KeyWordVer1 />
                    </ProtectedRoute>
                }
            />
            <Route
                path="/keywordVer1"
                element={
                    <ProtectedRoute>
                        <KeyWordVer1 />
                    </ProtectedRoute>
                }
            />
            <Route
                path="/keywordVer2"
                element={
                    <ProtectedRoute>
                        <KeyWordVer2 />
                    </ProtectedRoute>
                }
            />
            <Route
                path="/findMid"
                element={
                    <ProtectedRoute>
                        <FindMid />
                    </ProtectedRoute>
                }
            />
            <Route
                path="/findNaverRank"
                element={
                    <ProtectedRoute>
                        <FindNaverRank />
                    </ProtectedRoute>
                }
            />
            <Route
                path="/findNaverRankTracking"
                element={
                    <ProtectedRoute>
                        <FindNaverRankTracking />
                    </ProtectedRoute>
                }
            />
            <Route
                path="/dashboard"
                element={
                    <ProtectedRoute>
                        <DashBoard />
                    </ProtectedRoute>
                }
            />
        </Routes>
    );
};
export default Layout;
